/* eslint-disable no-unreachable */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import GetAllUsers from "../../../hooks/fetch-hooks/fetch-all/get-all-users";
import GetAddressByUserMappingId from "../../../hooks/fetch-hooks/get-address-by-userid/get-address-by-userid";
import GetPatientMappingsByUserId from "../../../hooks/fetch-hooks/get-patient-mappings-by-userid/get-patient-mappings-by-userid";
import { useModalMain } from "../../../contexts/modal";
import { TextField } from "../TextField";
import moment from "moment/moment";
import { request } from "../../../config/helpers/axios-instance";
const Constants = require("./Constants");
import { toast } from "react-toastify";
import classes from "../../../styles/MedicineForm.module.scss";
import CreateAddress from "../create-address";
import { useRef } from "react";
import { PRESORTED, STRIPS } from "../../../utils/constants";
import { useSourcesData } from "../../../hooks/fetch-hooks/get-sources";

function CreateOrder() {
    const [searchUser, setsearchUser] = useState('');
    const [userName, setUserName] = useState('')
    const { data: users, isFetching: isFetchingUsers } = GetAllUsers(searchUser, isNaN(searchUser) ? 'name' : 'contact_no');
    const [stopFetch, setStopFetch] = useState(false)
    const [filteredUsers, setFilteredUsers] = React.useState([]);
    const [selectedUser, setSelectedUser] = React.useState(0);
    const { data: patients, refetch } = GetPatientMappingsByUserId(!selectedUser ? 0 : selectedUser);
    const [filteredPatients, setFilteredPatients] = React.useState([]);
    const [selectedPatient, setSelectedPatient] = React.useState(0);
    const { data: patientAddress, refetch: AddressFetch } = GetAddressByUserMappingId(selectedPatient);
    const [patientId, setPatientId] = React.useState(0);
    const [addresses, setAddresses] = React.useState([]);
    const { closeModal, openModal } = useModalMain()
    const [addressesID, setAddressesID] = React.useState(0);
    const [prescriptionPayload, setPrescriptionPayload] = React.useState(
        Constants.prescriptionInitialValues
    );
    const [isAddressFormOpen, setIsAddressFormOpen] = useState(false);
    const [selectedUserdata, setSelectedUserData] = useState();
    const [selectedPatientdata, setSelectedPatientData] = useState();
    const [selectedSource, setSelectedSource] = useState('');
    const [selectedChannel, setSelectedChannel] = useState('');

    // Get sources data using the hook
    const { channels, getSourcesForChannels } = useSourcesData();

    // Get available channels for the selected source
    const availableSources = selectedChannel ? getSourcesForChannels(selectedChannel) : [];

    // Mirrors the `enabled` rule in GetAllUsers: a search only runs for a full
    // 10-digit number or a name of 2+ characters.
    const trimmedSearch = String(searchUser ?? '').trim();
    const isUserSearchActive = isNaN(trimmedSearch)
        ? trimmedSearch.length >= 2
        : /^\d{10}$/.test(trimmedSearch);
    const noUserFound =
        isUserSearchActive && !stopFetch && !isFetchingUsers && !!users && filteredUsers.length === 0;

    React.useEffect(() => {
        setFilteredPatients([]);
        // refetch() bypasses the hook's `enabled` guard, so check the id here too —
        // otherwise we request /mapUserPatient/admin/user/0 (and /undefined).
        if (selectedUser) refetch();
    }, [selectedUser]);

    useEffect(() => {
        if (selectedPatient) AddressFetch()
    }, [selectedPatient])

    React.useEffect(() => {
        if (patientAddress?.data?.data?.length > 0) {
            let patientAddresses = patientAddress?.data?.data?.map((item) => {
                return {
                    label: item.line,
                    id: item.id,
                };
            });
            // add patient address to the list of addresses until the user or patient changes and also check if the id is not already present
            setAddresses((prev) => {
                let newAddresses = [...prev, ...patientAddresses];
                let filteredAddresses = newAddresses.filter(
                    (item, index, self) =>
                        index === self.findIndex((t) => t.id === item.id)
                );
                return filteredAddresses;
            });
        } else {
            setAddresses([]);
            setAddressesID(0);
        }
    }, [patientAddress]);

    React.useEffect(() => {
        if (users && !stopFetch) {
            // The API replies 200 with `{ success: false, data: {} }` when no user matches,
            // so `rows` can be missing — never assume it is an array.
            const rows = users?.data?.data?.rows;
            setFilteredUsers(
                Array.isArray(rows)
                    ? rows.map((user) => {
                        return { label: user.name, id: user.id, contact_no: user.contact_no, drName: user.partnerUsers ? user.partnerUsers[0]?.partner?.type === 'DOCTOR' ? user.partnerUsers[0].partner.name : '' : '' };
                    })
                    : []
            );
        }
    }, [users]);

    React.useEffect(() => {
        if (patients && patients?.data?.data?.rows?.length > 0) {
            setFilteredPatients(
                patients?.data?.data?.rows?.map((item) => {
                    return {
                        label: item.Patient.name,
                        patientId: item.Patient.id,
                        id: item.id,
                        relationship: item.relationship,
                    };
                })
            );
        }
    }, [patients]);

    React.useEffect(() => {
        setSelectedPatient(filteredPatients[0]?.id);
        setPatientId(filteredPatients[0]?.patientId);
        setSelectedPatientData(filteredPatients[0]);
    }, [filteredPatients]);

    async function trackingImages(files) {

        if (files.length === 0) return [];

        let formData = new FormData();
        for (let i in files) {
            formData.append('files', files[i]);
        }

        let resUploadFiles = await request({
            url: "/file/upload/prescription/",
            method: "POST",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        })

        return resUploadFiles?.data?.data.map((item) => item.image || item.pdf);
    }
    // Prescription changes Here

    const onChangePrescription = (e) => {
        setPrescriptionPayload((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    // OnSubmit Starts Here
    const onSubmit = async (values, { resetForm }) => {

        try {
            // Checked first: the prescription below is saved before the order is.
            if (!(parseInt(values.noOfDays, 10) > 0)) {
                toast.error("Duration must be at least 1 day")
                return
            }

            if (!addresses.length > 0 || addressesID === 0) {
                toast.error("Please add address first")
                return
            }

            prescriptionPayload["userMappingId"] = selectedPatient
            prescriptionPayload["userId"] = selectedUser

            let imagesArray = await trackingImages(values.image);
            prescriptionPayload.links = imagesArray || [];

            let prescription = await request({
                method: "POST",
                url: "prescription/admin",
                data: prescriptionPayload,
            });

            if (!prescription?.data.success) {
                toast.error(prescription?.data?.error || "Something went wrong")
                return
            }

            if (prescription?.data?.success) {
                values['prescriptionId'] = prescription?.data?.data?.id;

                try {
                    const body = {
                        addressId: parseInt(addressesID),
                        address: addresses.find(address => address.id == addressesID),
                        userMappingId: parseInt(selectedPatient),
                        prescriptionId: parseInt(values.prescriptionId),
                        status: values.status,
                        noOfDays: parseInt(values.noOfDays),
                        startDate: values.startDate,
                        endDate: values.endDate,
                        notes: values.notes,
                        user: selectedUserdata,
                        patient: {
                            id: selectedPatientdata.patientId,
                            name: selectedPatientdata.label,
                        },
                        type: `INTERNAL_${values.type}`,
                        source: selectedSource,
                        channel: selectedChannel,
                    }

                    let response = await request({ method: "POST", url: "/userOrder/admin", data: body });


                    if (response.data.success) {
                        toast.success("Success")
                        resetForm({ values: '' })
                        closeModal()
                    }
                    if (!response.data.success) {
                        toast.error(response.data.error)
                    }
                }

                catch (error) {
                    toast.error("Wrong data")
                }
            }
        }
        catch (err) {
            toast.warn(err)
        }
    };

    // Handing search
    const handleSearch = (e) => {
        setUserName(e.target.value)
        if (isNaN(e.target.value)) {
            setsearchUser(e.target.value)
            setStopFetch(false)
            setSelectedUser(e.target.id);
        }
        else if (e.target.value.length === 10) {
            setsearchUser(e.target.value)
            setStopFetch(false)
            setSelectedUser(e.target.id);
        }

    }
    function openAddressForm() {
        setIsAddressFormOpen(true);
    }
    function toggleAddressCreateForm() {
        setIsAddressFormOpen(!isAddressFormOpen);
    }

    function handlePatientClick(e) {
        let value = filteredPatients[e.target.value]
        setSelectedPatient(value.id);
        setPatientId(value.patientId);
        setSelectedPatientData(value);
    }

    return (
        <div className="pb-4 max-h-[90vh] overflow-y-scroll">
            {isAddressFormOpen && < CreateAddress selectedUser={selectedUserdata} toggle={toggleAddressCreateForm} fetchAddress={AddressFetch} />}
            {!isAddressFormOpen && < Formik initialValues={Constants.initialValues} onSubmit={onSubmit}>
                {(props) => (
                    <Form>
                        <div className="py-2 px-4 flex justify-between items-center">
                            <h1 className="font-bold font-sans text-3xl text-white-900">
                                New Order
                            </h1>
                            <input
                                type="date"
                                name="date"
                                required
                                onChange={onChangePrescription}
                                defaultValue={prescriptionPayload.date}
                                className="border-white-z500 border-2 w-1/3 p-2 rounded-2xl font-semibold focus:outline-none active:outline-none font-sans text-sm"
                            />
                        </div>

                        <div className="mt-4 grid grid-cols-1 gap-4 items-center p-6 py-0 focus:outline-1 peer-active:outline-1">
                            {/* Dynaming Searching*/}
                            <div className="border-white-500 p-2 border-2 rounded-2xl">
                                <h6 className="font-sans text-xs ">User Name</h6>
                                <input type="text" autoComplete="off" name="user" className={classes.inputSearch2} value={userName} onChange={handleSearch} required={true} />
                                {filteredUsers.length > 0 && userName.length > 1 && (
                                    <>
                                        <div className={classes.Dropdown3}>
                                            <ul>
                                                {filteredUsers.length > 0 && filteredUsers.map((val, id) => {
                                                    return (
                                                        <li key={id} className='cursor-pointer' onClick={() => { setUserName(val.label), setFilteredUsers([]), setSelectedUser(val.id), setStopFetch(true), setSelectedUserData({ name: val.label, contact_no: val.contact_no, id: val.id }) }}><b>{val.id}</b>: {val.label} - {val.contact_no}</li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </>
                                )}
                                {noUserFound && userName.length > 1 && (
                                    <p className="font-sans text-xs text-red-600 mt-1">
                                        {isNaN(trimmedSearch)
                                            ? `No user found with the name "${userName}".`
                                            : `No user found with the number ${userName}. Please create the user first.`}
                                    </p>
                                )}
                            </div>
                            {/* Dynamic Searching Ends Here+= */}
                            {filteredPatients?.length > 0 && (
                                <div className="border-white-500 p-2 border-2 rounded-2xl">
                                    <h6 className="font-sans text-xs ">Patient</h6>
                                    <Field as="select" value={filteredPatients.findIndex((item) => item.id === selectedPatient)} onChange={handlePatientClick} name="patient" required className="w-full h-[2rem] p-0 m-0 focus:outline-none active:outline-none border-none active:border-none focus:border-none focus:ring-0 appearance-none">
                                        {filteredPatients.map((value, key) => {
                                            return (
                                                <>
                                                    <option key={key} value={key} onClick={() => {
                                                    }} >{value.label}
                                                        {"    - "}
                                                        {value.relationship}</option>
                                                </>
                                            )
                                        })}
                                    </Field>
                                </div>
                            )}
                            {addresses?.length > 0 && (
                                <div className="border-white-500 p-2 border-2 rounded-2xl">
                                    <h6 className="font-sans text-xs">Shipping Address</h6>
                                    { }
                                    <Field as="select" name="address" required className="w-full h-[2rem] p-0 m-0 focus:outline-none active:outline-none border-none active:border-none focus:border-none focus:ring-0 appearance-none">
                                        {addresses.map((value, key) => {
                                            return (
                                                <>
                                                    <option key={key} value={value.id} onClick={setAddressesID(value.id)}>{value.label}</option>
                                                </>
                                            )
                                        })}
                                    </Field>
                                </div>
                            )}
                            {filteredPatients?.length > 0 && <button type="button" className="bg-elm-600 rounded-2xl p-2 m-2 text-white-50 font-semibold" onClick={() => { openAddressForm() }}>Create Address</button>}
                            <div className="">
                                <TextField
                                    label="Doctor Name"
                                    name="drName"
                                    required
                                    onChange={onChangePrescription}
                                    type="text"
                                    placeholder="Enter Doctor Name"
                                />
                            </div>
                            <div className="">
                                <h6 className="font-sans text-xs">Channel</h6>
                                <select
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white-50 bg-clip-padding rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white-50 focus:border-blue-600 focus:outline-none"
                                    value={selectedChannel}
                                    onChange={(e) => {
                                        setSelectedChannel(e.target.value);
                                        if (selectedSource && e.target.value) {
                                            const newSourceChannels = getSourcesForChannels(e.target.value);
                                            if (!newSourceChannels.includes(selectedSource)) {
                                                setSelectedSource('');
                                            }
                                        } else if (!e.target.value) {
                                            setSelectedChannel('');
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select Channel</option>
                                    {channels.map((channelOption) => (
                                        <option key={channelOption} value={channelOption}>
                                            {channelOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="">
                                <h6 className="font-sans text-xs">Source</h6>
                                <select
                                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white-50 bg-clip-padding rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white-50 focus:border-blue-600 focus:outline-none"
                                    value={selectedSource}
                                    onChange={(e) => {
                                        setSelectedSource(e.target.value)
                                    }}
                                    disabled={!selectedChannel || availableSources.length === 0}
                                    required
                                >
                                    <option value="">
                                        {!selectedChannel ? 'Select Channel First' : 'Select Source'}
                                    </option>
                                    {availableSources.map((sourceOption) => (
                                        <option key={sourceOption} value={sourceOption}>
                                            {sourceOption}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 gap-4 items-center p-6 py-0">
                            <div className="grid grid-cols-5  gap-2 items-center">
                                <div className="col-span-2">
                                    <TextField label="Start Date" name="startDate" type="date" onChange={(e) => {
                                        props.setFieldValue('startDate', e.target.value)
                                        props.setFieldValue(
                                            "endDate",
                                            moment(e.target.value)
                                                .add(props.values.noOfDays - 1, "days")
                                                .format("YYYY-MM-DD")
                                        );
                                    }} />
                                </div>
                                <div className="">
                                    <TextField
                                        label="Duration"
                                        name="noOfDays"
                                        type="number"
                                        min={1}
                                        required
                                        value={props.values.noOfDays}
                                        onChange={(e) => {
                                            props.setFieldValue("noOfDays", e.target.value);
                                            props.setFieldValue(
                                                "endDate",
                                                moment(props.values.startDate)
                                                    .add(e.target.value - 1, "days")
                                                    .format("YYYY-MM-DD")
                                            );
                                        }}
                                    />
                                </div>
                                <div className="col-span-2">
                                    <TextField
                                        label="End Date"
                                        name="endDate"
                                        type="date"
                                        required
                                        value={props.values.endDate}
                                        // Update end date when start date is changed
                                        onChange={(e) => {
                                            props.setFieldValue("endDate", e.target.value);
                                            props.setFieldValue(
                                                "noOfDays",
                                                moment(e.target.value).diff(
                                                    moment(props.values.startDate),
                                                    "days"
                                                ) + 1
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 grid grid-cols-1 p-6 py-0">
                            <TextField
                                label="Notes"
                                name="notes"
                                type="text"
                                placeholder="Add a Note...."
                            />
                        </div>
                        <div className="mt-4 grid grid-cols-1 gap-4 items-center p-6 py-0">
                            <div className="flex justify-center">
                                <div className="w-full rounded-2xl">
                                    <h6 className="font-sans text-sm font-medium mb-1">
                                        Upload Prescription
                                    </h6>
                                    <input
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white-50bg-clip-padding rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white-50 focus:border-blue-600 focus:outline-none"
                                        type="file"
                                        name="image"
                                        id="image"
                                        multiple
                                        onChange={(event) => {
                                            props.setFieldValue("image", Array.from(event.target.files));
                                        }}
                                    />
                                </div>
                            </div>
                            <select
                                className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white-50 bg-clip-padding rounded-2xl transition ease-in-out m-0 focus:text-gray-700 focus:bg-white-50 focus:border-blue-600 focus:outline-none"
                                name="type"
                                required
                                value={props.values.type}
                                onChange={(e) => {
                                    props.setFieldValue("type", e.target.value)
                                }}
                            >
                                <option value="">Select Order Type</option>
                                <option value={PRESORTED}>Presorted</option>
                                <option value={STRIPS}>Strips</option>
                            </select>
                            <button
                                type="submit"
                                className="w-full h-[3rem] bg-elm-600 font-sans text-white-50 font-semibold py-2 rounded-2xl hover:bg-elm-700">
                                Create Order
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>}
        </div>
    );
}


// }

export { CreateOrder };
